import { render } from "./EditModel3dTable.vue?vue&type=template&id=16fec46c&scoped=true"
const script = {}

import "./EditModel3dTable.vue?vue&type=style&index=0&id=16fec46c&lang=scss"
import "./EditModel3dTable.vue?vue&type=style&index=1&id=16fec46c&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fec46c"]])

export default __exports__